import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Textbox, Custom, Publicacion, DateTimePicker, TextArea } from '@app/shared';
import { Validators } from '@angular/forms';


@Injectable()
export class PublicationsFormService {

  constructor() { }

  
  
  /**
   *  Construye y retorna el formulario para modificar una publicacion
   *
   * @param {TemplateRef<any>} templateUpload
   * @param {Publicacion} [publicacion]
   * @return {*}  {BaseControl<any>[]}
   * @memberof PublicationsFormService
   */
  getFormPubblication(
    templateUpload: TemplateRef<any>,
    publicacion?: Publicacion
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new TextArea({
        key: 'asunto',
        value: publicacion && publicacion.asunto ? publicacion.asunto : null,
        label: 'Asunto',
        placeholder: 'Ingrese una brebe descripción del asunto',
        rows: '3',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'publicado',
        type: 'checkbox',
        label: 'publicado',
        disabled: publicacion && publicacion.publicado ? publicacion.publicado : false,
        order: 2,
        size: 'col-12',
        value: publicacion && publicacion.publicado ? publicacion.publicado : false
      }),
      new DateTimePicker({
        key: 'fecha_publicacion',
        label: 'Fecha de publicación:',
        order: 3,
        disabled: true,
        pickerType: 'calendar',
        placeholder: 'Selecione una fecha',
        value: publicacion && publicacion.fecha_publicacion ?  new Date(publicacion.fecha_publicacion) : new Date(),
        validations: {
            validators: [Validators.required]
        }
    }),
      new Custom({
        key: 'documentos',
        label: 'Documento',
        order: 4,
        template: templateUpload
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/publications/shared/publications.form.service.ts